// extracted by mini-css-extract-plugin
export default {"input_active":"newInvoiceInfo_input_active__f9-g5","postnumber":"newInvoiceInfo_postnumber__fz4MS"};